<template>
  <div>
    <Card style="margin:0 2rem 1rem 2rem">
        <div class="Title"><Icon type="md-calendar" style="margin-right:.5rem"/>订单信息</div>
        <Divider />
        <Header :formItem="Headerlist" :State="State"/>
    </Card>

    <Card style="margin:0 2rem 1rem 2rem">
      <div class="Title"><Icon type="md-images" style="margin-right:.5rem"/>订单凭证</div>
        <Divider />
      <Voucher :url1="url1" :url2="url2" :State="State" :Payment_Voucher="Payment_Voucher" :Payment_Voucher2="Payment_Voucher2" :OrderID="OrderID"/>
    </Card>

    <Card style="margin:0 2rem 1rem 2rem">
      <div class="Title"><Icon type="md-images" style="margin-right:.5rem"/>订单明细</div>
        <Divider />
      <DetailList :OrderinfoLists="OrderinfoLists" :State="State"/>
    </Card>
  </div>
</template>

<script>
import Header from './OrderDetailHeader.vue'
import Voucher from './OrderDetailVoucher.vue'
import DetailList from './OrderDetailList.vue'
import { GetOrderMainData, GetOrderDetailData } from '../../../../api/Order.js'
export default {
  name: 'OrderDetail',
  components: {
    Header,
    Voucher,
    DetailList
  },
  props: {
    OrderID: String,
    State: String
  },
  data () {
    return {
      Headerlist: Object,
      url1: '',
      url2: '',
      Payment_Voucher: '',
      Payment_Voucher2: '',
      OrderinfoLists: []
    }
  },
  mounted: function () {
    this.GetOrderMainList()
    this.GetOrderDetailList()
  },
  methods: {
    // 获取订单主表数据
    GetOrderMainList () {
      GetOrderMainData(this.OrderID).then(res => {
        if (res.IsSuccess) {
          this.Headerlist = {
            OrderID: res.Data[0].OrderID,
            Customer_Name: res.Data[0].Customer_Name,
            State: res.Data[0].State,
            AdvanceCharge: res.Data[0].AdvanceCharge,
            TailMoney: res.Data[0].TailMoney,
            TailMoney1: res.Data[0].TailMoney,
            Total: res.Data[0].Total,
            Total1: res.Data[0].Total,
            Address: res.Data[0].Address,
            Contacts: res.Data[0].Contacts,
            Telephone: res.Data[0].Telephone,
            UserName: res.Data[0].UserName,
            UserID: res.Data[0].UserID,
            Freight: res.Data[0].Freight,
            Freight2: res.Data[0].Freight,
            Remark: res.Data[0].Remark,
            Order_Source: res.Data[0].Order_Source,
            StartTime: res.Data[0].StartTime,
            ReceiveTime: res.Data[0].ReceiveTime,
            BillingType: res.Data[0].BillingType,
            switch: '展开'
          }
          this.url1 = res.Data[0].AdvanceChargeVoucher
          this.url2 = res.Data[0].AdvanceChargeVoucher2
          this.Payment_Voucher = res.Data[0].Payment_Voucher
          this.Payment_Voucher2 = res.Data[0].Payment_Voucher2
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 获取订单明细数据
    GetOrderDetailList () {
      GetOrderDetailData(this.OrderID).then(res => {
        if (res.IsSuccess) {
          this.OrderinfoLists = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    }
  }
}
</script>
<style scoped>
.Title{
    font-size: 16px;
    color: #17233d;
    font-weight: 500;
    white-space: nowrap;
}
</style>>
